// The Shipping hub's package guide (?so=ID&pallet=ID): the order's package guide in OPERATOR mode with the
// Working-as ui, under a big Back button. The card comes from ./packageGuideSlot (features/packageGuide/
// PackageGuideCard); if that is ever null the panel links to the Sales Order page's guide instead.
import React from 'react';
import ErrorBoundary from '../../components/ErrorBoundary.jsx';
import PackageGuideCard from './packageGuideSlot';
import { salesOrderPalletPath } from '../../utils/scanCodes';
import { fulfillmentText } from './soBoard';

const styles = {
  bar: { display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 12, marginBottom: 12 },
  back: { minHeight: 48, fontSize: '1.05rem' },
  title: { fontSize: '1.35rem', fontWeight: 700 },
};

// signedPickup (shipping_signing.pickup on): the card's Confirm Pickup buttons start a customer-signed pickup instead.
export default function PackageGuidePanel({ salesOrderId, palletId = null, order = null, apiBase, ui, backLabel = 'Back', onClose, signedPickup = null }) {
  const soLabel = (order && order.order_number) || `SO #${salesOrderId}`;
  const soLink = palletId ? salesOrderPalletPath(salesOrderId, palletId) : `/sales-orders?id=${encodeURIComponent(salesOrderId)}`;
  return (
    <div data-testid="package-guide-panel">
      <div style={styles.bar}>
        <button type="button" className="btn btn-outline-secondary" style={styles.back} onClick={onClose}>
          ← {backLabel}
        </button>
        <span style={styles.title}>{soLabel}</span>
        {order && order.customer_name && <span className="text-muted">{order.customer_name}</span>}
        {order && order.fulfillment_type && (
          <span className="badge bg-light text-dark border">{fulfillmentText(order.fulfillment_type)}</span>
        )}
      </div>
      <ErrorBoundary label="The package guide">
        {PackageGuideCard ? (
          <PackageGuideCard salesOrderId={salesOrderId} apiBase={apiBase} focusPalletId={palletId}
            mode="operator" ui={ui} {...(signedPickup ? { signedPickup } : {})} />
        ) : (
          <div className="alert alert-info" data-testid="package-guide-fallback">
            <div className="mb-2">The package guide for {soLabel} opens on its Sales Order page for now.</div>
            <a className="btn btn-primary" style={{ minHeight: 48 }} href={soLink}>
              Open {soLabel}'s package guide
            </a>
          </div>
        )}
      </ErrorBoundary>
    </div>
  );
}
